import axios from "axios";

const UpdateDetailLessonAPI = async (token, secureId, data) => {
  try {
    const BASED_URL = process.env.REACT_APP_BASED_URL;
    const params = `/admin/lesson/update?token=${token}&secureId=${secureId}`;
    const url = `${BASED_URL}${params}`;
    const response = await axios.put(url, data);
    return response.data;
  } catch (err) {
    return err.response;
  }
};

export default UpdateDetailLessonAPI;
